import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { CreditCardBenefitListItemExtension } from './credit-card-benefit-list-item.extension';
import { CreditCardBenefitMetadataExtension } from './credit_card-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('credit_card')
    .add(BenefitMetadataExtensionInterface, new CreditCardBenefitMetadataExtension())
    .add(BenefitListItemExtensionInterface, new CreditCardBenefitListItemExtension())
    .build(),
);
